import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import SwitchButtonConfig from '@core/models/models/switch-button-config.model';
@Component({
  selector: 'caremoni-switch-button',
  templateUrl: './switch-button.component.html',
  styleUrl: './switch-button.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SwitchButtonComponent {

  @Input() checked: boolean = false;
  @Input() config: SwitchButtonConfig | undefined = undefined;

  @Output() onClick = new EventEmitter();


  @Input()  xdpad?: number = -1;
  @Input()  ydpad?: number = -1;
  @Input()  dpad?: number = -1;
  @Input()  tabdpad?: number = -1;
  @Input()  scaledpad?: number = -1;
  @Input()  xtabdpad?: number = -1;
  @Input()  ytabdpad?: number = -1;

  switchConfig: any = {};

  constructor() {

    if(!this.config) {
      this.config = new SwitchButtonConfig();
      const theme = localStorage.getItem('theme');
      if(theme === 'dark') {
        this.config.borderColor = '#888';
        this.config.background = 'transparent';
        this.config.backgroundHandle = '#888';
        this.config.checkedBackground = 'transparent';
        //this.config.checkedBackgroundHandle = '#fff';
        //this.config.checkedBorderColor = '#fff';
        this.config.shadow = 'none';
      }
    }
  }

  ngOnInit() {
    this.mergeConfig();
  }
  ngOnChanges() {
    this.mergeConfig();
  }
  
  onChangeData(event: any) {
    this.onClick.emit(event);
  }

  private mergeConfig() {

    this.config = new SwitchButtonConfig(this.config);

    this.switchConfig = {
      root: {
        width: this.config?.width,
        height: this.config?.height,
        gap: this.config?.gap,
  
        //Background
        background: this.config?.background,
        hoverBackground: this.config?.background,
        checkedBackground: this.config.checkedBackground,
        checkedHoverBackground: this.config.checkedBackground,
  
        //Border
        borderColor: this.config?.borderColor,
        hoverBorderColor: this.config?.borderColor,
        checkedBorderColor: this.config?.checkedBorderColor,
        checkedHoverBorderColor: this.config?.checkedBorderColor,
        borderWidth: this.config?.borderWidth,
        shadow: this.config?.shadow
      },
      handle: {
        //Background
        checkedBackground: this.config.checkedBackgroundHandle,
        checkedHoverBackground: this.config.checkedBackgroundHandle,
        background: this.config?.backgroundHandle, 
        hoverBackground: this.config?.backgroundHandle,
  
        borderRadius: '50%',
        size: this.config?.sizeHandle
      }
    };
  }
}
